import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import QRCode from "react-qr-code";
import { useAppStore } from '@/hooks/useAppStore';
import { useTheme } from '@/components/themes/ThemeProvider';

type EventData = {
  [key: string]: {
    title: string;
    start: number;
    expire: number;
    roomPrefix: string;
  };
};

// TODO - KV these
export const events: EventData = {
  "7KCYFDnISWryTfJLmOkfl": {
    title: "TOPAI",
    start: 1760775400000,
    expire: 1763367400000, //Nov 17 2025
    roomPrefix: 'TOP'
  },
  "M1sGvH2nKx8zDq9rL4pTw": {
    title: "PlugAndPlay Japan Summit",
    start: 1760775400000,
    expire: 1763367400000, //Nov 17 2025
    roomPrefix: 'PNP'
  },
  "f1a2B9cQr-W0n8LOHyfBtA": {
    title: "Techstars Tokyo Demo Day 2025",
    start: 1760775400000,
    expire: 1794960000000, //Nov 17 2026
    roomPrefix: 'TSA'
  },
  "v7dJEnFgm2M2gbcd9QPlB": {
    title: "Ramen Tech 2025",
    start: 1759676400000,
    expire: 1760022000000,
    roomPrefix: 'RMT'
  },
  "cxEF4z2VMpt38oeLZp1Ev": {
    title: "Fukuoka Growth Next",
    start: 1759676400000,
    expire: 1760022000000,
    roomPrefix: 'FGN'
  },
  "i5nTzHEGFFx1hI1QbI7ka": {
    title: "Agora",
    start: 1762300800000,  // Nov 5th
    expire: 1762560000000, // Nov 8th
    roomPrefix: 'AGA'
  },
  "CgtQ6XVDSkgTqq6bAL5xy": {
    title: "Osaka City",
    start: 1762732800000,
    expire: 1763122800000, // Nov 15th
    roomPrefix: 'OSA'
  },
  "9mjDuKLOqJm4bTJUmUbfw": {
    title: "Homebase",
    start: 1762732800000,
    expire: 1794960000000, // Nov 18th 2026
    roomPrefix: 'HBAE'
  },
  "76GeTm4VUFsyOWxOloaWQ": {
    title: "Tokyo AI",
    start: 1762732800000,
    expire: 1794960000000, // Nov 18th 2026
    roomPrefix: 'TAI'
  },
  "2bmqVhT104I4M6eIOQKg3": {
    title: "Tiktok Gaming",
    start: 1762732800000,
    expire: 1794960000000, // Nov 18th 2026
    roomPrefix: 'TGM'
  },
  "lndqeK1nlG1ixfHq5qoi8": {
    title: "Morado Ventures",
    start: 1762732800000,
    expire: 1765756800000, // Dec 15th 2025
    roomPrefix: 'MOR'
  },
  "olr2TMrmCk0mfSA4sinuT": {
    title: "Katayama",
    start: 1762732800000,
    expire: 1796083200000, // Dec 1st 2026
    roomPrefix: 'KYMA'
  },
   "s9FeM4NvOWvMlJ9cg9Z4W": {
    title: "Shibuya City",
    start: 1767571200000,
    expire: 1768867200000, // Jan 20 2026
    roomPrefix: 'SHB'
  },
  "HK9I3zGzfGoQhFENO5gVW": {
    title: "NEC-Cybersecurity",
    start: 1767571200000,
    expire: 1968867200000, // 2032
    roomPrefix: 'NEC'
  },
  "TeV3IfZQOeTywfxkVnt3K": {
    title: "Luma",
    start: 1767571200000,
    expire: 1769990400000, // 2026, feb 2
    roomPrefix: 'LMA'
  }
};

export function findEventFromId(eventId: string) {
  const matchingEvent = Object.keys(events).find(id => eventId == id);
  return matchingEvent ? events[matchingEvent].roomPrefix : null;
}

export function getShareableUrl(
  redirect: string
): string {
  const url = new URL(`${window.location.origin}/new-room?r=${redirect}`);
  return url.toString();
}

export const EventPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('id') // Get event ID from URL
  const qrCode = searchParams.get('qr') // Get event ID from URL
  const clientConfig = useAppStore((state) => state.clientConfig);
  const { resolvedTheme } = useTheme();

  // Use dark logo in dark mode if available, otherwise use regular logo
  const logoSrc = resolvedTheme === 'dark' && clientConfig?.config?.logoDark
    ? clientConfig.config.logoDark
    : clientConfig?.config?.logo;

  const [showEventEnded, setShowEventEnded] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  useEffect(() => {
    if (eventId && eventId in events) {
      const event = events[eventId];
      const now = Date.now();
      if (event && event.roomPrefix && now >= event.start && now <= event.expire) {
        if (qrCode) {
          setShowQRCode(true);
          const url = getShareableUrl(event.roomPrefix);
          setShareUrl(url);
        } else {
          localStorage.removeItem("rid");
          localStorage.removeItem("sid");
          setTimeout(() => {
            window.location.replace(`/new-room?r=` + event.roomPrefix);
          }, 100);
        }
      } else {
        setShowEventEnded(true);
      }
    } else {
      setShowEventEnded(true);
    }
  }, [eventId]);

  return (
    <>
      {showEventEnded && (<div
        className={"flex flex-col items-center justify-center p-12 chat-container fixed inset-0 gap-6 text-center text-xl tracking-wide font-bold"}
      >
        <div><img src="/assets/img/chotto-logo.png" width="300" /></div>
        <div>このイベントは終了しました。ご利用ありがとうございました。</div>
        <div>This event has ended. Thank you for using our service.</div>
        <div>本次活动已结束，感谢您使用我们的服务。</div>
      </div>
      )}
      {showQRCode && (<div className="flex flex-col chat-container">
        <div className="relative w-full min-h-screen flex items-center justify-center bg-cover bg-center">
          <div className="bg-black/40 p-8 rounded-2xl max-w-3xl w-full text-center text-white items-center">
            <div className="w-full flex justify-center mb-5">
              <img src={logoSrc} width={clientConfig?.config?.logoWidth || 200} />
            </div>
            <h1 className="text-3xl font-semibold mb-2">簡単に会話や交流ができる翻訳アプリ</h1>
            <p className="text-lg mb-6">
              A translation app that makes conversation and networking easy
            </p>

            <div className="flex justify-center mb-6">
              <div
                className="w-64 h-64 object-contain bg-white p-2 rounded-xl">
                <QRCode
                  value={shareUrl}
                  size={192} // Ensure this matches container size roughly
                  level="M" // Error correction level
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                />
              </div>
            </div>

            <p className="text-sm mb-1">
              このイベント専用の自分だけのチャットルームを作るにはQRコードをスキャン!
            </p>
            <p className="text-sm">
              Scan the QR code for your OWN personal chat room for this event!
            </p>
            <div className="p-4 items-center justify-center w-full flex mt-5">
              {clientConfig?.config.logo !== "/assets/img/chotto-logo.png" &&
                <div className='text-sm gap-2 flex flex-col'>
                  Powered by:
                    <img src="/assets/img/chotto-logo.png" alt="Chotto" className="h-8 w-auto" />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default EventPage;
